// // version: 1.0.0
// /* eslint-disable @typescript-eslint/restrict-template-expressions */
// /* eslint-disable @typescript-eslint/strict-boolean-expressions */
// /* eslint-disable @typescript-eslint/no-unused-vars */
// /* eslint-disable @typescript-eslint/explicit-function-return-type */
// /* eslint-disable @typescript-eslint/no-misused-promises */
// /* LAYOUT NAVBAR COMPONENT
//    ========================================================================== */
// import React, { useState } from 'react'

// interface HeaderProps {
//   sidebarOpen: boolean
//   setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>
// }

// function Header ({ sidebarOpen, setSidebarOpen }: HeaderProps) {
//   return (
//        <header className="sticky top-0 bg-white border-b border-slate-200 z-30">
//          <div className="px-4 sm:px-6 lg:px-8">
//            <div className="flex items-center justify-between h-16 -mb-px">
//              {/* Header: Left side */}
//              <div className="flex">
//                {/* Hamburger button */}
//                <button
//                  className="text-slate-500 hover:text-slate-600 lg:hidden"
//                  aria-controls="sidebar"
//                  aria-expanded={sidebarOpen}
//                  onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
//                    e.stopPropagation()
//                    setSidebarOpen(!sidebarOpen)
//                  }}
//                >
//                  <span className="sr-only">Open sidebar</span>
//                  <svg
//                    className="w-6 h-6 fill-current"
//                    viewBox="0 0 24 24"
//                    xmlns="http://www.w3.org/2000/svg"
//                  >
//                    <rect x="4" y="5" width="16" height="2" />
//                    <rect x="4" y="11" width="16" height="2" />
//                    <rect x="4" y="17" width="16" height="2" />
//                  </svg>
//                </button>
//              </div>
//            </div>
//          </div>
//        </header>
//   )
// }

// export default Header

// version: 2.0.0
/* eslint-disable multiline-ternary */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* LAYOUT NAVBAR COMPONENT
   ========================================================================== */
import React, { useState, useEffect } from 'react' // Added useEffect
import MenuIcon from '@mui/icons-material/Menu'
import MenuOpenIcon from '@mui/icons-material/MenuOpen'
import Button from '@mui/material/Button'
import UserMenu from '../../../components/DropdownProfile'
import { NavLink } from 'react-router-dom'
interface HeaderProps {
  sidebarOpen: boolean
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>
  sidebarExpanded: boolean // Add this
  setSidebarExpanded: React.Dispatch<React.SetStateAction<boolean>> // Add this
}

function Header ({ sidebarOpen, setSidebarOpen, sidebarExpanded, setSidebarExpanded }: HeaderProps) {
  const [isLargeScreen, setIsLargeScreen] = useState(false)

  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth >= 1024) // Tailwind's lg breakpoint
    }
    checkScreenSize() // Initial check
    window.addEventListener('resize', checkScreenSize)
    return () => window.removeEventListener('resize', checkScreenSize)
  }, [])

  const handleToggleSidebar = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    if (isLargeScreen) {
      setSidebarExpanded(!sidebarExpanded)
    } else {
      setSidebarOpen(!sidebarOpen)
    }
  }

  return (
    <header className="sticky top-0 bg-white border-b border-slate-200 z-30">
      <div className="px-2">
        <div className="flex items-center justify-between h-16">
          {/* Header: Left side */}
          <div className="flex items-center"> {/* MODIFIED: Added items-center */}
            {/* Hamburger button - Always visible */}
            <Button
              aria-controls="sidebar"
              aria-expanded={isLargeScreen ? sidebarExpanded : sidebarOpen}
              onClick={handleToggleSidebar}
              sx={{
                color: 'black',
                borderRadius: '50%', // Bo tròn mặc định nếu muốn
                minWidth: 'auto', // Đảm bảo nút không quá rộng
                padding: '8px', // Điều chỉnh padding cho phù hợp
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.02)', // Màu nền nhẹ khi hover
                  borderRadius: '50%' // Bo tròn khi hover
                },
                '&:active': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)', // Màu nền đậm hơn khi active
                  borderRadius: '50%' // Bo tròn khi active
                }
              }}
            >
              <span className="sr-only">
                {isLargeScreen
                  ? (sidebarExpanded ? 'Collapse sidebar' : 'Expand sidebar')
                  : (sidebarOpen ? 'Close sidebar' : 'Open sidebar')}
              </span>
              {isLargeScreen ? (
                // Icons for large screens (desktop)
                sidebarExpanded ? (
                  <MenuOpenIcon className="w-6 h-6 fill-current" /> // Icon khi sidebar đang mở rộng (để thu gọn)
                ) : (
                  <MenuIcon className="w-6 h-6 fill-current" /> // Icon khi sidebar đang thu gọn (để mở rộng)
                )
              ) : (
                // Hamburger icon for small screens
                sidebarOpen ? (
                  <MenuOpenIcon className="w-6 h-6 fill-current" /> // Icon when mobile sidebar is open (to close)
                ) : (
                  <MenuIcon className="w-6 h-6 fill-current" /> // Icon when mobile sidebar is closed (to open)
                )
              )}
            </Button>
            <NavLink
              end
              to="/"
              className="block ml-3"
              onClick={() => {
                setSidebarOpen(false)
              }}>
              <p className="text-lg font-semibold m-0">Gx.Thánh Gia</p> {/* MODIFIED: Added text styling and m-0 to remove paragraph default margin */}
            </NavLink>
          </div>
          {/* Header: Right side */}
          <div className="flex items-center">
            <UserMenu align="right" />
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
